import AbstractEntity from "../AbstractEntity";

export default class QuotationItem extends AbstractEntity {
    _id;
    _name;
    _description;
    _price;
    _quantity;
    _validationHash;
    _emissionFactor;
    _validate;
    _createdAt;
    _defaultItemId;
    _standardizedItemId;
    _quotationId;

    getId() {
        return this._id;
    }

    getName() {
        return this._name;
    }

    getDescription() {
        return this._description;
    }

    getPrice() {
        return this._price;
    }

    getQuantity() {
        return this._quantity;
    }

    getValidationHash() {
        return this._validationHash;
    }

    getEmissionFactor() {
        return this._emissionFactor;
    }

    isValidate() {
        return this._validate;
    }

    getCreatedAt() {
        return this._createdAt;
    }

    getDefaultItemId() {
        return this._defaultItemId;
    }

    getStandardizedItemId() {
        return this._standardizedItemId;
    }

    getQuotationId() {
        return this._quotationId;
    }

    getClassName() {
        return "quotation_item";
    }
}